<section *ngIf="responseElements.length;" [attr.id]="sectionId" class="page-topic">
  <div [ngClass]="{
      'bg-grey-card': color == 'grey',
      'pt-md-100': firstElement
    }" class="pt-40 pb-50 section py-5">
    <div class="container">
      <div data-view="card_teaser" data-items_per_row="3" data-icon="it-calendar">
        <div class="row row-title g-0">
          <div class="col">
            <div class="border-bottom d-md-flex justify-content-between">
              <h2 class="mb-3">{{ headingText }}</h2>
            </div>
          </div>
        </div>
        <div class="py-4 results">
          <div class="row mx-lg-n3">
            <div class="card-wrapper card-teaser-wrapper card-teaser-wrapper-equal card-teaser-block-3">
              <app-compact-card *ngFor="let element of responseElements" [data]="element"
                class="font-sans-serif card card-teaser card-teaser-image no-after rounded shadow-sm mb-0 border border-light"></app-compact-card>
            </div>
          </div>
        </div>
        <ng-container *ngIf="status.totalPage">
          <app-paginator [currentPage]="status.currentPage + 1" [totalPages]="status.totalPage"
            (pageChanged)="onPageChange($event)"></app-paginator>
        </ng-container>
      </div>
    </div>
  </div>
</section>

<section class="page-topic" id="section-{{ headingText }}" *ngIf="isLoading">
  <div
    [ngClass]="{
      'bg-grey-card': this.color == 'grey',
      'pt-md-100': this.firstElement
    }"
    class="pt-40 pb-50 section py-5"
  >
    <div class="container">
      <div
        data-view="card_teaser"
        data-block_subtree_query="classes [public_service] and sort [name=>asc] and raw[submeta_topics___main_node_id____si] in [108] and subtree [74] and raw[meta_depth_si] range [3,*]"
        data-subtree_filter="raw[meta_path_si]"
        [attr.data-limit]="status.displayedItems"
        data-items_per_row="3"
        data-icon="it-settings"
      >
        <div class="row row-title g-0">
          <div class="col">
            <div class="border-bottom d-md-flex justify-content-between">
              <h2 class="mb-3">{{ headingText }}</h2>
            </div>
          </div>
        </div>
        <div class="py-4 results">
          <div class="row mx-lg-n3">
            <div
              class="card-wrapper card-teaser-wrapper card-teaser-wrapper-equal card-teaser-block-3"
            >
              <div
                class="font-sans-serif card card-teaser no-after rounded shadow-sm mb-0 border border-light"
              >
                <div class="card-body pb-5">
                  <div class="category-top">
                    <span class="title-xsmall-semi-bold fw-semibold">
                      <span class="category-placeholder"></span>
                    </span>
                  </div>
                  <h3 class="card-title text-paragraph-medium u-grey-light">
                    <span class="title-placeholder"></span>
                  </h3>
                  <div class="text-paragraph-card u-grey-light m-0">
                    <div class="mt-1">
                      <span class="text-placeholder"></span>
                    </div>
                  </div>
                </div>
                <a class="read-more" href="#">
                  <span class="text">
                    <span class="link-placeholder"></span>
                  </span>
                </a>
              </div>
              <div
                class="font-sans-serif card card-teaser no-after rounded shadow-sm mb-0 border border-light"
              >
                <div class="card-body pb-5">
                  <div class="category-top">
                    <span class="title-xsmall-semi-bold fw-semibold">
                      <span class="category-placeholder"></span>
                    </span>
                  </div>
                  <h3 class="card-title text-paragraph-medium u-grey-light">
                    <span class="title-placeholder"></span>
                  </h3>
                  <div class="text-paragraph-card u-grey-light m-0">
                    <div class="mt-1">
                      <span class="text-placeholder"></span>
                    </div>
                  </div>
                </div>
                <a class="read-more" href="#">
                  <span class="text">
                    <span class="link-placeholder"></span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-4">
          <button
            type="button"
            [routerLink]="showAllRedirect"
            data-element="all-services"
            class="btn btn-primary px-5 py-3 full-mb text-button"
          >
            <span> {{ showAllText }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
